import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import { useInstance } from 'intact-react';
import { useState } from '../../hooks/useState';
import { useDraggable } from '../../hooks/useDraggable';
import { getInitMeta, getItemHeight } from './useTranslate';
import { throttle } from '../utils';
export function useMouseEvents(translate, list) {
  var instance = useInstance();
  var marginTop = useState(0);
  var dragged;
  var initY;
  var y;
  var itemHeight;
  var deltaY;
  var _useDraggable = useDraggable({
      onStart: function onStart(e) {
        dragged = false;
        initY = y = e.clientY;
        var meta = getInitMeta(instance);
        itemHeight = meta.itemHeight;
        deltaY = meta.deltaY;
      },
      onMove: function onMove(e) {
        var deltaY = e.clientY - y;
        dragged = !!deltaY;
        y = e.clientY;
        var _deltaY = y - initY;
        var offsetIndex = Math.floor(Math.abs(_deltaY) / itemHeight);
        if (offsetIndex) {
          if (_deltaY < 0) {
            offsetIndex = -offsetIndex;
          }
          setByRelativeIndex(-offsetIndex, -_deltaY, false);
          initY = y;
        }
        translate.set(translate.value + deltaY);
      },
      onEnd: function onEnd() {
        translate.set(-marginTop.value + deltaY);
      }
    }),
    start = _useDraggable.start,
    dragging = _useDraggable.dragging;
  function setByRelativeIndex(index, deltaY, isSetTranslate) {
    var _context;
    var data = list.data,
      value = list.value,
      setValue = list.setValue;
    var i = _findIndexInstanceProperty(_context = data.value).call(_context, function (v) {
      return v.value === value.value;
    });
    var l = data.value.length;
    var newValue = data.value[(l + i + index) % l].value;
    setValue(newValue, true);
    marginTop.set(marginTop.value + (deltaY || index * itemHeight));
    if (isSetTranslate) {
      translate.set(translate.value - itemHeight * index);
    }
  }
  function onWheel(e) {
    e.preventDefault();
    itemHeight = getItemHeight();
    if (e.deltaY > 0) {
      // down
      setByRelativeIndex(1, null, true);
    } else {
      setByRelativeIndex(-1, null, true);
    }
  }
  // throttle onWheel
  var _onWheel = throttle(onWheel, 0, function (e) {
    return e.preventDefault();
  });
  function onClick(item, index) {
    // if _dragged, do not trigger click event, #123
    if (dragged) return;
    var _instance$get = instance.get(),
      count = _instance$get.count;
    var half = Math.floor(count / 2);
    var itemHeight = getItemHeight();
    translate.set(translate.value - itemHeight * (index - half));
    marginTop.set(marginTop.value + itemHeight * (index - half));
    list.setValue(item.value, true);
  }
  return {
    onStart: start,
    marginTop: marginTop,
    dragging: dragging,
    onWheel: _onWheel,
    onClick: onClick
  };
}